import React, { useState, useEffect, forwardRef } from 'react';
import './Sidebar.css';
import { MenuList } from './Menu';
import axios from 'axios';
import * as endPoints from '../../Constants/Endpoints';
import { useNavigate, useLocation } from 'react-router-dom';
import { logout } from "../../Authentication Services/AuthService";
import { IoLogOut, IoLockClosed } from "react-icons/io5";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { GetConfig } from '../../Authentication Services/AuthService';

const Sidebar = forwardRef(({ isOpen, menuState, loggingOut }, ref) => {
  const { t } = useTranslation('sidebar');
  const navigate = useNavigate();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState('Dashboard');
  const [config, setConfig] = useState();

  useEffect(() => {
    GetConfigWrapper();
  }, []);

  useEffect(() => {
    setActiveItem(
      MenuList.find(x => "/" + x.to === location.pathname)?.title ?? ""
    );
  }, [location.pathname]);

  const hasMiniSiteAccess = config?.features?.miniSite;

  const isItemLocked = (item) => {
    if (item.to === 'manage-site') {
      return !hasMiniSiteAccess;
    }
    return false;
  };

  const menuClick = async (option) => {

    if (isItemLocked(option)) {
      return;
    }

    setActiveItem(option.title);

    try {
      const res = await axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Authenticated,
        { withCredentials: true }
      );

      if (option.to === "logout")
      {
        logoutClicked()
        return;
      }

      if (res.status === 200) {
        navigate("/" + option.to);
      }

      menuState(false);
    } catch (e) {
      navigate(0);
    }
  };

  function GetConfigWrapper() {
    GetConfig()
      .then((res) => {
        setConfig(res.data);
      })
      .catch(() => {});
  }

  function logoutClicked() {
    loggingOut(true);
    logout()
      .then(() => {
        navigate('/login');
      })
      .catch(() => {
        navigate("/login");
      })
      .finally(() => {
        loggingOut(false);
      });
  }

  const renderLockedIcon = () => (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="mini-site-locked-tooltip">
          {t('sidebar.tooltips.miniSiteLocked')}
        </Tooltip>
      }
    >
      <span className="menu-lock" aria-label={t('sidebar.tooltips.miniSiteLocked')}>
        <IoLockClosed />
      </span>
    </OverlayTrigger>
  );

  return (
    <div ref={ref} className={`sidebar ${isOpen ? 'open' : 'collapsed'}`}>
      <div className="sidebar-content">
      <div className="sidebar-menu">
        {MenuList.map((item, index) => {
          const locked = isItemLocked(item);

          return (
            <div
              key={index}
              className={`sidebar-item ${activeItem === item.title ? 'active' : ''} ${locked ? 'locked' : ''}`}
              onClick={() => menuClick(item)}
              title={
                !isOpen
                  ? locked
                    ? `${t(item.title)} - ${t('sidebar.tooltips.miniSiteLockedShort')}`
                    : t(item.title)
                  : ''
              }
            >
              <span className="icon">{item.iconStyle}</span>

              {isOpen && (
                <span className="menu-label-wrap">
                  <span className="menu-label">{t(item.title)}</span>
                  {locked && renderLockedIcon()}
                </span>
              )}
            </div>
          );
        })}
        </div>

                  {/* <div
              className={`sidebar-item ${activeItem === "Logout" ? 'active' : ''}`}

    onClick={() => logoutClicked()}
    title={!isOpen ? t('sidebar.menu.logout') : ''}
  >
    <span className="icon"><IoLogOut /></span>
    {isOpen && <span className="menu-label">{t('sidebar.menu.logout')}</span>}
  </div> */}

        {/* <div
          style={{ borderTop: "1px solid #cbcbcb91" }}
          className={`sidebar-item ${activeItem === "Logout" ? 'active' : ''}`}
          onClick={() => logoutClicked()}
          title={!isOpen ? t('sidebar.menu.logout') : ''}
        >
          <span className="icon"><IoLogOut /></span>
          {isOpen && <span className="menu-label">{t('sidebar.menu.logout')}</span>}
        </div> */}

          {/* <div
              className={`sidebar-logout sidebar-item ${activeItem === "Logout" ? 'active' : ''}`}

    onClick={() => logoutClicked()}
    title={!isOpen ? t('sidebar.menu.logout') : ''}
  >
    <span className="icon"><IoLogOut /></span>
    {isOpen && <span className="menu-label">{t('sidebar.menu.logout')}</span>}
  </div> */}
      </div>
    </div>
  );
});

export default Sidebar;